import { render } from "./MotivoRechazoCatalogList.vue?vue&type=template&id=0a91fb65&scoped=true"
import script from "./MotivoRechazoCatalogList.vue?vue&type=script&lang=js"
export * from "./MotivoRechazoCatalogList.vue?vue&type=script&lang=js"

import "./MotivoRechazoCatalogList.vue?vue&type=style&index=0&id=0a91fb65&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a91fb65"]])

export default __exports__